export default {
      id: "iso-usage",
      viewBox: "0 0 66 66",
      url: __webpack_public_path__ + "sprite.svg#iso",
      toString: function () {
        return this.url;
      }
    }